// Ajusta a posição do WhatsApp inferior caso o contador inferior também esteja habilitado
function handleWhatsLatPos() {
  const $countdownFixed = $('.countdown-wrapper.fixed.bottom');
  const $whatsLateralBottom = $('.contatos-lateral.bottom-right, .contatos-lateral.bottom-left');
  if ($countdownFixed.length > 0 && $whatsLateralBottom.length > 0) {
    if (isMedia('xs') || isMedia('sm')) {
      const countdownHeight = $countdownFixed.outerHeight() + 10;
      $whatsLateralBottom.css('margin-bottom', countdownHeight);
    }
  } else {
    $whatsLateralBottom.css('margin-bottom', 0);
  }
}
handleWhatsLatPos();

// Collapse colunas
(function () {
  'use strict';

  $('.footer-collapse .footer-tit').on('click', function () {
    if (isMedia('sm') || isMedia('xs')) {
      const $tit = $(this);
      const $col = $tit.parent();
      const $content = $col.find('.footer-col-content');
      if (!$col.hasClass('active')) {
        $col.addClass('active');
        $content.slideDown();
      } else {
        $col.removeClass('active');
        $content.slideUp();
      }
    }
  });
})();

// ------------------------------------
// Voltar ao topo
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $goTop = $('.go-top');
  const $window = $(window);

  // Exibe ou oculta o botão ao rolar a página
  toggleGoTop();
  $(window).on(
    'scroll',
    debounce(function () {
      toggleGoTop();
    }, 100),
  );

  // Evento de click no botão
  $goTop.on('click', function () {
    smoothScroll('html');
  });

  // Exibe ou oculta o botão
  function toggleGoTop() {
    const scrollTop = $window.scrollTop();
    if (scrollTop > 500) {
      $goTop.addClass('active');
    } else {
      $goTop.removeClass('active');
    }
  }
})();

// Exibe o modal da página institucional
(function () {
  'use strict';

  // Variáveis
  const $modalConsultaPedido = $('#modal-consulta-pedido');
  const $campoConsultaPedido = $('#cod-pedido');
  const $btnConsultaPedido = $('.btn-consulta-pedido');

  if ($campoConsultaPedido.length > 0) {
    handleNumConsulta();
  }

  // Exibe o modal
  $('[href="#consulta-pedido"]').on('click', function (ev) {
    ev.preventDefault();
    modalOpen('modal-consulta-pedido');
  });
  $('.header-rasteio-btn, .menu-mobile-rastreio').on('click', function (ev) {
    ev.preventDefault();
    const link = $(this).attr('href');
    if (link && link != '' && link != '#') {
      //window.location.href = link;
      window.open(link, '_blank');
    } else {
      modalOpen('modal-consulta-pedido');
    }
  });

  // Ao digitar no campo
  $campoConsultaPedido.on('input change', handleNumConsulta);
  function handleNumConsulta() {
    const codPedido = $campoConsultaPedido.val() || '';
    $campoConsultaPedido.val(codPedido.toUpperCase());
    if (validaCodPedido()) {
      $btnConsultaPedido.prop('disabled', false);
    } else {
      $btnConsultaPedido.prop('disabled', true);
    }
  }

  // Ao clicar no botão
  $btnConsultaPedido.on('click', function (ev) {
    ev.preventDefault();
    if (validaCodPedido()) {
      getPedido();
    } else {
      showAlert('Atenção', 'Informe o código do pedido.', 'warning');
    }
  });

  // Ao pressionar Enter no campo
  $campoConsultaPedido.on('keyup', function (ev) {
    if (ev.which === 13) {
      if (validaCodPedido()) {
        getPedido();
      }
    }
  });

  // Valida a código digitado
  function validaCodPedido() {
    let codPedido = $campoConsultaPedido.val();
    return codPedido && codPedido != '';
  }

  // Consulta o pedido
  function getPedido() {
    if (!previewMode) {
      let codPedido = $campoConsultaPedido.val();
      codPedido = codPedido.replace('#', '').toUpperCase();
      const urlConsultaPedido = urlBase + 'core/acoes/checkout/searchOrder.php';
      const data = {
        order_token: codPedido,
        store_token: publicToken,
      };
      showLoader();
      $.getJSON(urlConsultaPedido, data, function (result) {
        //console.log(result);
        if (result && result.token != '') {
          let urlPedido = urlBaseLp + 'checkout/pedido/' + result.token;
          location.href = urlPedido;
        } else {
          hideLoader();
          showAlert('Não encontrado!', 'Não encontramos nenhum pedido para o código informado.', 'danger');
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        console.log(qXHR);
        hideLoader();
        showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
      });
    }
  }
})();

// Links selos
(function () {
  'use strict';
  $('.footer-selos li').each(function () {
    const $el = $(this);
    const $link = $el.find('a');
    const $img = $el.find('img');
    const siteDomain = 'https://' + location.host;
    // Site seguro (Google)
    if ($img.data('src').includes('selo3.png')) {
      $link.attr('href', 'https://transparencyreport.google.com/safe-browsing/search?url=' + siteDomain);
    }
    // Certificado SSL
    if ($img.data('src').includes('selo2.png')) {
      $link.attr('href', 'https://www.sslshopper.com/ssl-checker.html#hostname=' + siteDomain);
    }
  });
})();
